import { Suspense } from 'react';
import { Img, ImgProps } from 'react-image';
import { Loader } from '../Loader';

interface TypeProps extends ImgProps {
  alt?: string;
}

export const Image = ({ alt = 'image', ...rest }: TypeProps) => {
  return (
    <Suspense>
      <Img loader={<Loader />} alt={alt} {...rest} />
    </Suspense>
  );
};
